export enum PlayingSurfaceTypeEnum {
  SyntheticGrass = "Synthetic Grass",
  NaturalGrass = "Natural Grass",
  HybridGrass = "Hybrid Grass",
  Sand = "Sand",
  Gravel = "Gravel",
}
